import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Header, Page, Content } from '@backstage/core-components';
import { DashboardView } from '../DashboardView/DashboardView';
import { DomainAssessmentView } from '../DomainAssessmentView/DomainAssessmentView';
import { FindingsView } from '../FindingsView/FindingsView';
import { ComplianceView } from '../ComplianceView/ComplianceView';
import { MaturityView } from '../MaturityView/MaturityView';

const useStyles = makeStyles(theme => ({
  tabsContainer: {
    marginBottom: theme.spacing(3),
  },
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`audit-tabpanel-${index}`}
      aria-labelledby={`audit-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

export const AuditPage = () => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Page themeId="tool">
      <Header
        title="Digital Systems Audit"
        subtitle="MoH Digital Health Assessment — WHO-Aligned Framework v3"
      />
      <Content>
        <Paper className={classes.tabsContainer}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Dashboard" />
            <Tab label="Domain Assessments" />
            <Tab label="Findings" />
            <Tab label="Compliance" />
            <Tab label="Maturity Model" />
          </Tabs>
        </Paper>

        <TabPanel value={activeTab} index={0}>
          <DashboardView />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <DomainAssessmentView />
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <FindingsView />
        </TabPanel>
        <TabPanel value={activeTab} index={3}>
          <ComplianceView />
        </TabPanel>
        <TabPanel value={activeTab} index={4}>
          <MaturityView />
        </TabPanel>
      </Content>
    </Page>
  );
};
